import type { TrialVariant } from './types';

export type ProductShell = {
  startOnTranslation: boolean;
};

const HOME_FIRST_SHELL: ProductShell = {
  startOnTranslation: false,
};

const TRANSLATION_FIRST_SHELL: ProductShell = {
  startOnTranslation: true,
};

export const getProductShell = (variant: null | TrialVariant): ProductShell =>
  variant === 'C' ? TRANSLATION_FIRST_SHELL : HOME_FIRST_SHELL;
